import { Button } from '@cms/components/data/Button'
import { ISystemTemplate, SUBTYPES } from '@dl/declarations'
import clsx from 'clsx'
import { useCallback } from 'react'
import { TemplateForm } from '../../components/forms/TemplateForm'
import { DataPart } from '../../components/ui/DataPart'
import PageContainer from '../../components/ui/PageContainer'
import { generateSearchParam, renderSubtypeLabel } from '../../utils/helpers'
import { renderRouteOptions, Routes, TemplatesPath } from '../../utils/routes'

const TemplatesPage = () => {

    const renderItem = useCallback((item: ISystemTemplate) => {
        return (
            <div
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'flex items-center justify-start gap-8',
                    'border border-cs-700 rounded-md',
                )}
                // to={{
                //     pathname: Routes.TEMPLATES,
                //     search: `?${generateSearchParam(TemplatesPath, "mode", "update")}&${generateSearchParam(TemplatesPath, "id", item._id)}`,
                // }}
                key={item._id}
            >
                <div
                    className='bg-cs-200 text-cs-900 font-semibold p-1'
                >
                    {renderSubtypeLabel(item.subtypeObject!, "SHORT")}
                </div>

                <div className='w-full grid grid-cols-6 items-center justify-between gap-4'>
                    <h4 className='col-span-2 text-cs-600 font-semibold'>{item?.info?.name}</h4>

                    <p className='col-span-3'>
                        {item?.info?.description}
                    </p>

                    <div
                        className='flex items-center gap-2'
                    >
                        <Button
                            inputVariant='none'
                            as='link'
                            to={{
                                pathname: Routes.TEMPLATES,
                                search: `?${generateSearchParam(TemplatesPath, "mode", "update")}&${generateSearchParam(TemplatesPath, "id", item._id)}`,
                            }}
                        >
                            Edit
                        </Button>

                        <Button
                            inputVariant='white_text_blue_bg'
                            as='link'
                            to={{
                                pathname: Routes.EDITOR,
                                search: `?${generateSearchParam(TemplatesPath, "id", item._id)}`,
                            }}
                        >
                            Create Story
                        </Button>
                    </div>
                </div>
            </div>
        )
    }, [])

    return (
        <PageContainer
            title={renderRouteOptions(Routes.TEMPLATES).title}
        >
            <DataPart<ISystemTemplate>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    noOfColumns: "1",
                    renderItem: renderItem
                }}

                queryOptions={{
                    basePath: TemplatesPath,
                }}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true
                }}
                searchOptions={{
                    allow: true
                }}

                filters={{
                    subtypes: {
                        type: 'select',
                        label: 'Subtypes',
                        options: [],
                        allowMultiSelect: true,
                        hide: true
                    },
                }}

                form={<TemplateForm />}

                subtypes={[
                    SUBTYPES.NEWS,
                    SUBTYPES.RESEARCH,
                ]}
            />
        </PageContainer>
    )
}

export default TemplatesPage